export const TabId = Object.freeze({
	guests: 'guests',
	employees: 'employees',
});
